import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Tab from 'UIKit/Tab'
import Tabs from 'UIKit/Tabs'
import Text from 'UIKit/Text'
import { RouteConfig } from 'config/constants/route'
import { useRouter } from 'hooks/useRouter'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'
import { Icons } from 'svgs'

const StyledItemContainer = styled(Tab)<{ $active: boolean }>`
  display: flex;
  align-items: center;
  position: relative;
  border-radius: ${({ theme }) => theme.radii.modal};
  height: 32px;
  padding: 12px;
  opacity: 0.6;
  z-index: 1;

  ${Text} {
    overflow: hidden;
    max-width: 100px;
  }

  ${({ $active }) =>
    $active &&
    css`
      opacity: 1;
      ${Text} {
        max-width: 100px;
      }
    `}

  ${({ theme }) => theme.mediaQueries.sm} {
    ${Text} {
      max-width: 0px;
    }

    ${({ $active }) =>
      $active &&
      css`
        opacity: 1;
        ${Text} {
          max-width: 100px;
        }
      `}
  }

  ${({ theme }) => theme.mediaQueries.xxl} {
    ${Text} {
      max-width: 100px;
    }
  }
`

const Container = styled(Tabs)`
  align-items: center;
  justify-content: space-between;

  background: ${({ theme }) => theme.colors.backgroundAlt5};
  backdrop-filter: blur(15px);
  border-radius: ${({ theme }) => theme.radii.tiny};
  box-sizing: border-box;

  max-width: 230px;
  max-height: 42px;
`

const StyledNewIcon = styled(Box)`
  position: absolute;
  top: 2px;
  left: 45%;
  transform: translateX(-50%);
`

const StyledIndicator = styled(Box)`
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.08);
  border-radius: ${({ theme }) => theme.radii.tiny};
  max-height: 92px !important;
`

enum CasinoSportSelectorValue {
  Sport = 'sport',
  Casino = 'casino',
}
const CasinoSportSelector: React.FC<BoxProps> = ({ ...props }) => {
  const router = useRouter()
  const isSportPage = router.pathname.startsWith(RouteConfig.Sport)
  const value = isSportPage ? CasinoSportSelectorValue.Sport : CasinoSportSelectorValue.Casino
  const onValueChanged = (value: CasinoSportSelectorValue) => {
    router.push(value === CasinoSportSelectorValue.Casino ? '/' : RouteConfig.Sport)
  }
  const { t } = useTranslation()

  return (
    <Container
      id="casinosportselector"
      value={value}
      onTagChanged={onValueChanged}
      indicator={<StyledIndicator />}
      disabledScroll
      p={'4px'}
      {...props}
    >
      <StyledItemContainer id="casino" $active={!isSportPage} value={CasinoSportSelectorValue.Casino}>
        <Icons.CasinoGameIcon />
        <Text fontSize="14px" ml="4px" lineHeight="none">
          {t('Casino')}
        </Text>
      </StyledItemContainer>

      <StyledItemContainer id="sport" $active={isSportPage} value={CasinoSportSelectorValue.Sport} disabled>
        <Icons.SportGameIcon />
        <Text fontSize="14px" ml="4px" lineHeight="none">
          {t('Sport')}
        </Text>
        <StyledNewIcon>
          <Icons.ComingSecondary />
        </StyledNewIcon>
      </StyledItemContainer>
    </Container>
  )
}

export default CasinoSportSelector
